<template>
    <div>
        operationControl
    </div>
</template>

<script>
    export default {
        name: 'operationControl',
    }
</script>

<style lang="scss" scoped>

</style>